export default [
  {
    path: "/reservoirs",
    name: "reservoirs",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Резервуары",
      permissions: ["tank:index"],
    },
  },
];
